import { orderlessFilter } from "@/utils/filter";
import { isNil } from "lodash";

export function showsSelectedValue<T>(
  {
    value,
    renderInputValue,
    labelFn,
  }: {
    value: T | null | undefined;
    renderInputValue?: (item: T) => string;
    labelFn: (item: T) => string;
  },
  inputValue: string,
): boolean {
  return (
    !isNil(value) && inputValue === (renderInputValue ? renderInputValue(value) : labelFn(value))
  );
}

export function defaultFilterFn<T>(
  { items, labelFn }: { items: T[]; labelFn: (item: T) => string },
  inputValue: string,
) {
  return orderlessFilter(items, labelFn, inputValue);
}
